import { render, staticRenderFns } from "./SearchFilterLabel.vue?vue&type=template&id=2f0cc621&"
import script from "./SearchFilterLabel.vue?vue&type=script&lang=js&"
export * from "./SearchFilterLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports